export default __webpack_public_path__ + "static/media/Blue-Android-3.4129cec0.png";